<template>
  <div class="m-total wh-flex-center" :style="{color: color,width: `${size}px`,height: `${size}px`}">
    <span class="total-num">{{ num }}</span>
    <span class="total-txt">{{ txt }}</span>
  </div>
</template>

<script>
export default {
  name: 'RingCenter',
  props: {
    color: {
      type: String,
      default: '#fff'
    },
    size: {
      type: Number,
      default: 130
    },
    num: {
      type: [String, Number],
      default: '0'
    },
    txt: {
      type: [String, Number],
      default: '总量'
    }
  }
}
</script>

<style scoped>
  .m-total{
    width: 130px;
    height: 130px;
    flex-direction: column;
    line-height: 1;
    border-radius: 50%;
    background-image: linear-gradient(to bottom, rgba(55, 59, 76, 0.48), rgba(11, 12, 15, 0.48));
  }
  .total-num{
    padding: 10px 0;
    font-size: 20px;
  }
  .total-txt{
    padding: 10px;
    font-size: 20px;
    border-top: 1px solid #e7eff9;
  }
</style>
